import { Icons } from "@/components/icons"
import { ProviderBrand } from "@/types"

const getProviderBrand = (): ProviderBrand => {
  const hostname = window.location.hostname

  if (hostname.endsWith("aivc.vc")) {
    return {
      icon: Icons.headline,
      name: "AIVC",
      title: "Headline AIVC",
      aiName: "AIVC",
    }
  }

  return {
    icon: Icons.logo,
    name: "Codeer.AI",
    title: "Codeer.AI",
    aiName: "Codeer.AI",
  }
}

export { getProviderBrand }
export default getProviderBrand
